import { render, staticRenderFns } from "./proposal-modal-image.vue?vue&type=template&id=42a27966"
import script from "./proposal-modal-image.vue?vue&type=script&lang=js"
export * from "./proposal-modal-image.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports